import { Injectable } from '@angular/core';
import { IDocumentEntityMappedItem } from '@app/logic/documents/interfaces/i.document.mapped';

@Injectable()
export class ManageSchemeDataService {
    public documents = [] as IDocumentEntityMappedItem[];
    constructor() { }
}
